export interface Testimonial {
  id: string;
  name: string;
  avatar: string;
  content: string;
  role: string;
  rating: number;
}

export const testimonials: Testimonial[] = [
  {
    id: 'test-1',
    name: '小林',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20warm%20genuine%20smile%2C%20natural%20lighting%2C%20clean%20minimal%20background%2C%20professional%20headshot%2C%20friendly%20expression&width=120&height=120&seq=testimonial-1&orientation=squarish',
    content: '通过17c一起找到了三个和我一样热爱古镇摄影的朋友，上个月一起去了乌镇，拍了很多好照片，还成了很好的朋友。这个平台真的改变了我的社交方式！',
    role: '摄影爱好者',
    rating: 5,
  },
  {
    id: 'test-2',
    name: '阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20confident%20smile%2C%20outdoor%20enthusiast%2C%20natural%20lighting%2C%20clean%20minimal%20background%2C%20friendly%20headshot&width=120&height=120&seq=testimonial-2&orientation=squarish',
    content: '以前周末总是宅在家里打游戏，加入17c一起后几乎每个周末都有安排。已经参加了五次徒步活动，身体素质明显变好了，还认识了很多好朋友！',
    role: '户外运动爱好者',
    rating: 5,
  },
  {
    id: 'test-3',
    name: '晓雯',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20gentle%20smile%2C%20artistic%20vibe%2C%20natural%20lighting%2C%20clean%20minimal%20background%2C%20warm%20headshot&width=120&height=120&seq=testimonial-3&orientation=squarish',
    content: '作为一名刚来北京工作的人，17c一起让我快速找到了归属感。参加了尤克里里小组后，不仅学会了一门乐器，更重要的是认识了一群志同道合的小伙伴。',
    role: '音乐爱好者',
    rating: 5,
  },
  {
    id: 'test-4',
    name: '大鹏',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20friendly%20laugh%2C%20casual%20style%2C%20natural%20lighting%2C%20clean%20minimal%20background%2C%20professional%20headshot&width=120&height=120&seq=testimonial-4&orientation=squarish',
    content: '17c一起的桌游之夜是我每周最期待的事！以前总是凑不够人玩，现在每周五都能认识新朋友、玩新游戏。社区的归属感特别强！',
    role: '桌游爱好者',
    rating: 5,
  },
  {
    id: 'test-5',
    name: '美琪',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20bright%20smile%2C%20fashionable%2C%20natural%20lighting%2C%20clean%20minimal%20background%2C%20warm%20headshot&width=120&height=120&seq=testimonial-5&orientation=squarish',
    content: '我参加了三次烘焙课程，每次都学到新东西。最开心的是能把自己做的甜点分享给身边的人，看到他们吃得开心，我也特别满足！',
    role: '烘焙爱好者',
    rating: 5,
  },
  {
    id: 'test-6',
    name: '老张',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20warm%20smile%2C%20intellectual%2C%20natural%20lighting%2C%20clean%20minimal%20background%2C%20friendly%20headshot&width=120&height=120&seq=testimonial-6&orientation=squarish',
    content: '读书会是我最喜欢的活动形式。以前一个人读书容易半途而废，但有了每周的讨论，读书变成了一种期待。和书友们的交流经常让我有新的启发。',
    role: '读书爱好者',
    rating: 5,
  },
];